import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import TitleWithIcon from './TitleWithIcon';

import s from './PanelWithTitleAndIcon.scss';

function PanelWithTitleAndIcon({ children, className, icon, id, note, strongShadow, title }) {
  return (
    <div
      className={classNames(s.container, className, { [s.strong_shadow]: strongShadow })}
      id={id}
    >
      <TitleWithIcon icon={icon} title={title} note={note} />

      { children }
    </div>
  );
}

PanelWithTitleAndIcon.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
  id: PropTypes.string,
  note: PropTypes.string,
  strongShadow: PropTypes.bool,
  title: PropTypes.string.isRequired
};

PanelWithTitleAndIcon.defaultProps = {
  className: '',
  id: null,
  note: '',
  strongShadow: false
};

export default PanelWithTitleAndIcon;
